// Central place for all replaceable links.
// PLACEHOLDER: replace APP_STORE_URL and GOOGLE_PLAY_URL with the live store listings.
export const APP_STORE_URL = "#app-store-placeholder";
export const GOOGLE_PLAY_URL = "#google-play-placeholder";
export const CONTACT_EMAIL = "hello@lookaura.app"; // PLACEHOLDER: replace with the official contact address
